import { render, staticRenderFns } from "./Governance.vue?vue&type=template&id=2c36050c&"
import script from "./Governance.vue?vue&type=script&lang=js&"
export * from "./Governance.vue?vue&type=script&lang=js&"
import style0 from "./Governance.vue?vue&type=style&index=0&id=2c36050c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports